import { useContext, useState, useEffect } from "react";
import { ModalContext } from "../../../utils/modal/ModalProvider";
import { DialogEnum, showDialog } from "../../../utils/dialog/Dialog";
import { IAM_PATH, IAM_SERVER_SERVICE_USER, IAM_SERVER_SERVICE_GROUP, IAM_SERVER_SERVICE_ACOUNT } from "../../../utils/Config";
import Loading from "../../../utils/loading/Loading";
import axios from "../../../utils/api/axios";
import styles from "../../../utils/modal/DetailModal.module.css";
import { format } from "date-fns";
import { containsXss } from "../../../utils/security/XssFilter";
import { decrypt, encrypt } from "../../../utils/crypto/AES";
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export const GroupUserDetailModal = ({ update, userId, products }) => {
    const { closeModal } = useContext(ModalContext);
    const [loading, setLoading] = useState(false);
    const [serviceUserList, setServiceUserList] = useState([]);   // 전체 서비스 유저 [{userId, name}]
    const [groupUserList, setGroupUserList] = useState([]);       // 현재 그룹 유저 [{userId}]
    const [availableUsers, setAvailableUsers] = useState([]);     // 그룹에 미포함된 유저 [{userId, name}]
    const [assignedUsers, setAssignedUsers] = useState([]);       // 그룹에 포함된 유저 [{userId, name}]
    const [selectedAvailable, setSelectedAvailable] = useState([]);
    const [selectedAssigned, setSelectedAssigned] = useState([]);


    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = () => setShowPassword(!showPassword);



    const today = new Date().toISOString().split('T')[0]; // "2025-06-27"

    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [status, setStatus] = useState();
    const [isNull, setIsNull] = useState(false); //빈 값 확인

    const [formData, setFormData] = useState({
        id: userId,
        groupId: '',
        email: '',
        password: '',
        product: '',
        plan: '',
        userName: '',
        startDate: startDate,
        endDate: endDate,
        status: status
    });

    const [userInfo, setUserInfo] = useState({
        id: sessionStorage.getItem("id"),
        userId: sessionStorage.getItem("userId"),
        userName: sessionStorage.getItem("userName"),
        groupId: sessionStorage.getItem("groupId"),
        groupName: sessionStorage.getItem("groupName"),
        role: sessionStorage.getItem("role")
    })

    const statusMap = {
        active: "활성화",
        deactive: "미할당",
        expiration: "만료"
    };
    useEffect(() => {
        fetchPageData();
        setLoading(false)
    }, []);

    const formatDate = (timestamp) => {
        const date = new Date(Number(timestamp)); // timestamp는 숫자 혹은 문자열
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const fetchPageData = async () => {
        try {
            const url = IAM_PATH + IAM_SERVER_SERVICE_ACOUNT + "/get/" + userId;
            const res = await axios.get(url);
            const data = res.data.data;

            setFormData({
                id: data.userId,
                groupId: data.groupId,
                email: data.email,
                password: decrypt(data.password),
                product: data.product,
                plan: data.plan,
                userName: data.userName,
                startDate: formatDate(data.startDate),
                endDate: formatDate(data.endDate),
                status: data.status
            });

        } catch (e) {
            console.error(e);
            showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
        }
    };

    // 저장 로직
    const handleSave = () => {
        // 시작일: 00:00:00
        const startDate = new Date(`${formData.startDate}T00:00:00`);
        
        // 종료일: 23:59:59
        const endDate = new Date(`${formData.endDate}T23:59:59`);
        
        if (startDate > endDate) {
            alert("종료일은 시작일보다 뒤 날짜를 선택해야 합니다.");
            return;
        }

        for (let key in formData) {
            const value = formData[key];
            if (value === '') {
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            } else if (typeof value === 'string' && containsXss(value)) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }));
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }
        setIsNull(false);


        const pageParams = {
            id: userId,
            groupId: formData.groupId,
            email: formData.email,
            password: encrypt(formData.password),
            product: formData.product,
            plan: formData.plan,
            userName: formData.userName,
            startDate: startDate.getTime(),
            endDate: endDate.getTime(),
            status: formData.status
        };

        const url = IAM_PATH + IAM_SERVER_SERVICE_ACOUNT + "/update";
        axios.post(url, pageParams)
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                    update();
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
        formData.startDate = e.target.value;
    };

    const handleEndDateChange = (e) => {
        if (formData.startDate > e.target.value) {
            alert("종료일은 시작일보다 뒤 날짜를 선택해야 합니다.");
        } else {
            setEndDate(e.target.value);
            formData.endDate = e.target.value;
        }
    };

    const handleStatusChange = (e) => {
        setStatus(e.target.value);
        formData.status = e.target.value;
    };

    const handleDelete = () => {
        setLoading(true);

        const url = IAM_PATH + IAM_SERVER_SERVICE_ACOUNT + "/delete/" + userId;

        axios.post(url)
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                    update();
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
            .finally(() => {
                setLoading(false);
            })

    }

    /**
     * //일반유저는 비밀번호랑 사용자만 교체 가능
     * 
     */
    const handleProductChange = (e) => {
        const selectedProductId = e.target.value;
        const selectedPlans = products[selectedProductId]?.plans || [];

        setFormData((prev) => ({
            ...prev,
            product: selectedProductId,
            plan: ''  // 첫 번째 요금제 기본 선택
        }));
    };
    const handlePlanChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            plan: e.target.value
        }));
    };

    return (
        <div style={{ overflow: "auto" }}>
            {loading ? <Loading /> :
                <div>
                    <ul className={styles.layer__listWrap}>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>제품명</p>
                            {userInfo.role === 'SYS_ADMIN' ? (
                                <select
                                    name="product"
                                    className={styles.layer__listInput}
                                    value={formData.product}
                                    style={{ appearance: "auto" }}
                                    onChange={handleProductChange}
                                >
                                    {Object.entries(products).map(([id, product]) => (
                                        <option key={id} value={id}>
                                            {product.name}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    type="text"
                                    className={styles.layer__listInput}
                                    value={products[formData.product]?.name || formData.product}
                                    readOnly
                                    style={{ backgroundColor: '#00000010', cursor: "default" }}
                                />
                            )}
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>요금제</p>
                            {userInfo.role === 'SYS_ADMIN' ? (
                                <select
                                    name="plan"
                                    className={styles.layer__listInput}
                                    value={formData.plan}
                                    style={{ appearance: "auto" }}
                                    onChange={handlePlanChange}
                                >
                                    <option value="">선택</option>
                                    {(products[formData.product]?.plans || []).map((plan) => (
                                        <option key={plan.id} value={plan.id}>
                                            {plan.plan}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    type="text"
                                    className={styles.layer__listInput}
                                    value={products[formData.product]?.plans.find(plan => plan.id == formData.plan)?.plan || ''}
                                    readOnly
                                    style={{ backgroundColor: '#00000010', cursor: "default" }}
                                />
                            )}
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>아이디</p>

                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"email"}
                                value={formData.email}
                                onChange={handleChange}
                                // readOnly={userInfo.role !== 'SYS_ADMIN'}
                                // style={userInfo.role !== 'SYS_ADMIN' ? { backgroundColor: '#00000010', cursor: "default" } : undefined}
                                readOnly={true}
                                style={{ backgroundColor: '#00000010', cursor: "default" }}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>비밀번호</p>

                            <input className={styles.layer__listInput}
                                type={showPassword ? 'text' : 'password'}
                                name={"password"}
                                value={formData.password}
                                maxLength={20}
                                onChange={handleChange}
                            />
                            <button type="button" onClick={togglePassword} className={styles.eyeButton}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>사용자</p>

                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"userName"}
                                value={formData.userName}
                                onChange={handleChange}
                                maxLength={30}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>시작일</p>
                            <input className={styles.layer__listInput}
                                type={"date"}
                                name={"startDate"}
                                value={formData.startDate}
                                onChange={handleStartDateChange}
                                onKeyDown={(e) => e.preventDefault()}
                                readOnly={userInfo.role !== 'SYS_ADMIN'}
                                style={userInfo.role !== 'SYS_ADMIN' ? { backgroundColor: '#00000010', cursor: "default" } : { cursor: "pointer" }}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>종료일</p>
                            <input className={styles.layer__listInput}
                                type={"date"}
                                name={"endDate"}
                                value={formData.endDate}
                                onChange={handleEndDateChange}
                                onKeyDown={(e) => e.preventDefault()}
                                style={userInfo.role !== 'SYS_ADMIN' ? { backgroundColor: '#00000010', cursor: "default" } : { cursor: "pointer" }}
                                readOnly={userInfo.role !== 'SYS_ADMIN'}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>상태</p>
                            {/* <select name={"status"} className={styles.layer__listInput} value={formData.status}
                                    style={{appearance: "auto"}}
                                    onChange={handleStatusChange}
                                    >
                                <option value={"deactive"} defaultValue={true}>비활성화</option>
                                <option value={"active"} >활성화</option>
                                <option value={"expiration"}>만료</option>                                
                            </select> */}
                            {/* {userInfo.role === 'SYS_ADMIN' ? ( */}
                            <select
                                name="status"
                                className={styles.layer__listInput}
                                value={formData.status}
                                style={{ appearance: "auto" }}
                                onChange={handleStatusChange}
                            >
                                <option value="deactive">미할당</option>
                                <option value="active">할당됨</option>
                                <option value="expiration">만료</option>
                            </select>
                            {/* ) : ( */}
                            {/* <input
                                    type="text"
                                    className={styles.layer__listInput}
                                    value={statusMap[formData.status] || '알 수 없음'}
                                    readOnly
                                    style={{ backgroundColor: '#00000010', cursor: "default"}}
                                /> */}
                            {/* )} */}
                        </li>
                    </ul>

                    {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
                    <div className={styles.layer__sensorBtnBox}>
                        {userInfo.role === 'SYS_ADMIN' && (
                            <button className={styles.layer__deleteBtn} onClick={handleDelete}>삭제</button>
                        )}
                        <button className={styles.layer__modifyBtn} onClick={handleSave}>수정</button>
                    </div>
                </div>
            }
        </div>
    );
};
